module.exports = "<ion-app>\n  <ion-router-outlet></ion-router-outlet>\n</ion-app>\n<app-loader></app-loader>\n<network-watemark></network-watemark>\n"